import { render } from "./Loading.vue?vue&type=template&id=380b0c23&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=380b0c23&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bomoindustrial-vue/bomoindustrial-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380b0c23"]])

export default __exports__